import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OmniGeralRestService } from './../../omni-rest/omni-geral/omni-geral-rest.service';

export interface EstadoCivil {
  codigo: string;
  descricao: string;
}

@Injectable()
export class EstadoCivilService {

  constructor(
    private http: HttpClient,
    private _restService: OmniGeralRestService
  ) { }

  findEstadoCivil(): Observable<EstadoCivil[]> {
    return this.http.get<EstadoCivil[]>('assets/estado-civil.json');
  }

  getEstadosCivis():Observable<any> {
    return this._restService.get('estados-civis');
  }
}
